import { observable } from 'mobx';
import { noop } from '@src/utils/common-util';
import useMount from '@src/utils/hooks/use-mount';
import { autobind } from 'core-decorators';
import getPageLocalesData from '@src/global-locales/get-page-locales-data';
import { COOKIE_FLAG } from '@src/components/cookie-modal/cookie-tips-modal/store';

const pageLocalesData = getPageLocalesData();
const cookieInfo = pageLocalesData.cookieInfo;

class CookieSettingModalStore {
  exitAllModal = noop;

  exitSettingModal = noop;

  onClose = noop;

  rejectOptionalCookies = noop;

  acceptOptionalCookies = noop;
  @observable isShow = false;
  /**
   * 是否允许cookies
   * @type {{analytics: boolean, necessary: boolean}}
   */
  @observable
  acceptCookies = {
    necessary: true,
    analytics: false
  };

  /**
   * 展示内容 - 0: 首页 1: 必不可少的cookie 2: 用于分析的cookie
   * @type {number}
   */
  @observable showType = 0;
  /**
   * 数据分析的cookie列表
   * @type {[]}
   */
  @observable
  analyseCookiesList = [
    {
      name: '_ga',
      provider: 'Google Analytics',
      duration: cookieInfo._ga_duration,
      description: cookieInfo._ga_description
    },
    {
      name: '_ga_XXXXXXXXXX',
      provider: 'Google Analytics',
      duration: cookieInfo._ga_x_duration,
      description: cookieInfo._ga_x_description
    },
    {
      name: '_gid',
      provider: 'Google Analytics',
      duration: cookieInfo._gid_duration,
      description: cookieInfo._ga_x_description
    }
  ];
  /**
   * 必要的cookies列表
   * @type {[]}
   */
  @observable
  necessaryCookiesList = [
    { name: COOKIE_FLAG, provider: 'Seasun Games', duration: cookieInfo.cookie_flag_duration, description: cookieInfo.cookie_flag_description },
    { name: 'session_id', provider: 'Seasun Games', duration: cookieInfo.session_id_duration, description: cookieInfo.session_id_description },
    { name: 'session_id_', provider: 'Seasun Games', duration: cookieInfo.session_id_duration, description: cookieInfo.session_id_description }
  ];

  constructor({ ...rest } = {}) {
    Object.assign(this, rest);
  }
  /**
   * 点击"确定"时回调
   */
  @autobind
  onConfirmCookieOptionsClick() {
    if (this.acceptCookies.analytics) {
      this.acceptOptionalCookies();
    } else {
      this.rejectOptionalCookies();
    }
  }
  /**
   * 修改是否接受cookie的状态
   */
  @autobind
  onChangeAcceptCookieStatus(type) {
    this.acceptCookies[type] = !this.acceptCookies[type];
  }

  onCloseClick() {}

  /**
   * 跳转到对应的index
   * @param index
   */
  @autobind
  redirectToPage(index) {
    this.showType = index;
  }

  /**
   * 返回首页
   */
  @autobind
  backToIndex() {
    this.showType = 0;
  }

  use() {
    useMount(() => {
      this.isShow = true;
    });
  }
}

export default CookieSettingModalStore;
